import {
    ActivityParentEntityId,
    formatPhoneNumber,
    PhoneNumberE164,
    TaskTypeId,
} from "@sp-crm/core";
import { ActivityTypeLabel } from "components/tasks/activity-type-name";
import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { SmsConversation } from "./sms-conversation";

interface SendSmsPanelProps {
    isOpen: boolean;
    onDismiss: () => void;
    recipient: PhoneNumberE164;
    activityTypeId: TaskTypeId | null;
    entityId: ActivityParentEntityId | null;
}

export const SendSmsPanel: React.FC<SendSmsPanelProps> = props => {
    const { isOpen, onDismiss, recipient, activityTypeId, entityId } = props;

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.large}
            headerText={`Your Conversation with ${formatPhoneNumber(recipient)}`}>
            <ActivityTypeLabel activityTypeId={activityTypeId} />
            <SmsConversation
                recipient={recipient}
                activityTypeId={activityTypeId}
                entityId={entityId}
                onClose={onDismiss}
            />
        </Panel>
    );
};
